import { type ReactNode } from 'react';
import { Button } from '@/components/ui';
import { SignupFields } from './signup-fields';
import { LegalCheckbox } from './legal-checkbox';
import { type FormState } from '../hooks/use-form-state';

type Props = FormState & {
  pending: boolean;
  onSubmit: () => void;
};

function Heading(): ReactNode {
  return (
    <h2 className="text-center font-display text-base font-bold text-text-primary sm:text-lg">
      Crear cuenta
    </h2>
  );
}

export function SignupFormContent(p: Props): ReactNode {
  return (
    <>
      <Heading />
      <SignupFields data={p.data} onChange={p.setData} errors={p.fieldErrors} />
      <LegalCheckbox
        agreed={p.agreed}
        onToggle={p.toggleAgreed}
        error={p.agreedError}
      />
      {p.error && <p className="text-xs text-error">{p.error}</p>}
      <Button
        size="lg"
        className="w-full"
        disabled={p.pending}
        onClick={p.onSubmit}
      >
        Crear cuenta
      </Button>
    </>
  );
}
